export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { duration: 1.8 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToSequencePoint = (fraction) => {
  const el = document.getElementById("cinematic");
  if (!el) return;
  const y = el.offsetTop + el.offsetHeight * fraction;
  if (window.__lenis) {
    window.__lenis.scrollTo(y, { duration: 2 });
  } else {
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};
